const groupPrefixPurchase = createApiRoute(ApiModule.PURCHASE, ApiAuthorization.EMPLOYEE, ApiDataModel.PURCHASE_ORDERS)

export const apiPurchaseOrder = {
	generatePurchaseOrder: async (id: number): Promise<any> => {
		const { data } = await apiCommon<any>(`${groupPrefixPurchase}/create`, {
			method: 'POST',
			body: { plan_id: id },
		})

		return data
	},
}
